import api, { setTokens, clearTokens, isAuthenticated } from './api'

export interface Utente {
  id: number
  email: string
  nome: string
  cognome?: string
  ruolo: 'utente' | 'admin'
  avatarUrl?: string
}

interface LoginResponse {
  message: string
  utente: Utente
  accessToken: string
  refreshToken: string
}

interface RegisterData {
  email: string
  password: string
  nome: string
  cognome?: string
}

/**
 * Registrazione nuovo utente
 */
export async function register(data: RegisterData): Promise<Utente> {
  const response = await api.post<LoginResponse>('/auth/register', data)
  setTokens(response.accessToken, response.refreshToken)
  return response.utente
}

/**
 * Login utente
 */
export async function login(email: string, password: string): Promise<Utente> {
  const response = await api.post<LoginResponse>('/auth/login', { email, password })
  setTokens(response.accessToken, response.refreshToken)
  return response.utente
}

/**
 * Logout
 */
export async function logout(): Promise<void> {
  try {
    const refreshToken = localStorage.getItem('refreshToken')
    if (refreshToken) {
      await api.post('/auth/logout', { refreshToken })
    }
  } catch {
    // Ignora errori
  } finally {
    clearTokens()
  }
}

/**
 * Ottiene profilo utente corrente
 */
export async function getProfile(): Promise<Utente | null> {
  if (!isAuthenticated()) return null
  try {
    return await api.get<Utente>('/auth/profile')
  } catch {
    clearTokens()
    return null
  }
}

/**
 * Aggiorna profilo
 */
export async function updateProfile(data: { nome?: string; cognome?: string }): Promise<Utente> {
  return api.patch<Utente>('/auth/profile', data)
}

/**
 * Cambia password
 */
export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await api.patch('/auth/profile/password', { currentPassword, newPassword })
  clearTokens() // Richiede nuovo login
}

export { isAuthenticated }
